const hotels = {
  back: "Rug", // translated
  rooms: "Kamers", // translated
  viewPictures: "Bekijk foto's", // translated
  showMore: "laat meer zien", // translated
  bookingInformation: "Boekingsinformatie", // translated
  cancellationPolicy: "Annuleringsvoorwaarden", // translated
  from: "Van", // translated
  to: "tot", // translated
  cancellationIs: "annulering is", // translated
  free: "vrij", // translated
  chargeableWithFeeOf: "belast met een vergoeding van", // translated
  prebook: "Vooraf boeken", // translated
  guests: "Gasten", // translated
  payment: "Betaling", // translated
  byClicking: "Door te klikken", // translated
  next: "Volgende", // translated
  youAreAgreeingToOur: "je gaat akkoord met onze", // translated
  termsAndConditions: "Voorwaarden", // translated
  previous: "Vorig", // translated
  cancel: "Annuleren", // translated
  mealPlan: "Maaltijdplan", // translated
  roomType: "Kamertype", // translated
  description: "Beschrijving", // translated
  readLess: "Lees minder", // translated
  readMore: "Lees verder", // translated
  facilities: "Faciliteiten", // translated
  viewLess: "Minder weergeven", // translated
  viewMore: "Bekijk meer", // translated
  less: "minder", // translated
  more: "meer", // translated
  notAvailable_short: "Nvt", // translated
  backToHotelList: "Terug naar hotellijst", // translated
  viewOnMap: "Bekijk op kaart", // translated
  sleeps: "Slaapt", // translated
  adults: "volwassenen", // translated
  yearsOld: "jaar oud", // translated
  type: "Type", // translated
  bedding: "beddengoed", // translated
  selectRoom: "Selecteer kamer", // translated
  city: "Stad", // translated
  checkIn: "Check in", // translated
  checkOut: "Uitchecken", // translated
  date: "Datum", // translated
  persons: "Personen", // translated
  stillOnTrialQuestionToUpgrade: "Oeps! Het lijkt erop dat je nog een proeflidmaatschap hebt. U moet een bevestigd lid zijn om boekingen te maken. Wil je nu upgraden?", // translated
  stillOnTrialQuestionToUpgradeNonElligib: "Oeps! Het lijkt erop dat je nog niet bent geabonneerd. U moet een bevestigd lid zijn om boekingen te maken. Wil je nu upgraden?", // translated
  completeProfile: "Vul eerst uw gebruikersprofiel in", // translated
  upgrade: "Upgrade", // translated
  close: "Dichtbij", // translated
  viewDetails: "Details bekijken", // translated
  name: "Naam", // translated
  rating: "Beoordeling", // translated
  budget: "Begroting", // translated
  orderBy: "Bestellen door", // translated
  priceLowestFirst: "Prijs: laagste eerst)", // translated
  priceHighestFirst: "Prijs: hoogste eerst)", // translated
  ratingLowestFirst: "Beoordeling (laagste eerst)", // translated
  ratingHighestFirst: "Beoordeling (hoogste eerst)", // translated
  starRatingAndPrice: "Sterrenclassificatie en prijs", // translated
  select: "Selecteer", // translated
  reset: "Resetten", // translated
  apply: "Toepassen", // translated
  filterBy: "Filteren op", // translated
  myProfile: "Mijn profiel", // translated
  login: "Log in", // translated
  roomOnly: "Alleen kamer", // translated
  bedAndBreakfast: "Bed & Breakfast", // translated
  halfBoard: "Halfpension", // translated
  fullBoard: "Vol pension", // translated
  allInclusive: "All Inclusive", // translated
  filter: "Filter", // translated
  mapView: "Kaartweergave", // translated
  results: "resultaten", // translated
  listView: "Lijstweergave", // translated
  newSearch: "Nieuwe zoekopdracht", // translated
  editSearch: "Zoekopdracht bewerken", // translated
  all: "Alle", // translated
  multiple: "Meerdere", // translated
  editProfile: "Bewerk profiel", // translated
  backToHotelsList: "Terug naar de lijst met hotels", // translated
  roomName: "Kamer naam", // translated
  mealType: "Maaltijdtype", // translated
  freeCancellation: "Gratis afzegging", // translated
  yes: "Ja", // translated
  no: "Nee", // translated
  filters: "Filters", // translated
  cancellationNonRefundable: "Annulering kan niet worden gerestitueerd", // translated
  hotels: "Hotels", // translated
  off: "Uit", // translated
  biggestSavingsFirst: "Grootste besparingen eerst", // translated
  performNewSearch: "Voer een nieuwe zoekopdracht uit", // translated
  hotelRating: "Hotelbeoordeling", // translated
  hotel: "Hotel", // translated
  dates: "Datums", // translated
  any: "Elk", // translated
  selectRooms: "Selecteer Kamers", // translated
  accommodation: "Accommodatie", // translated
};

export default hotels;
